/*
 * topical-prescription (schema)
 */
import { boolean, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"
import { producers } from "../producer/producer.schema"

export const topicalPrescriptions = schema.table("topical_prescriptions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, {
		onDelete: "set null",
	}),
	producerId: uuid("producer_id").references(() => producers.id, { onDelete: "set null" }),

	// --- Prescription ---
	// Grams: 50 | 75 | 100 | 200 | null (= "other")
	grams: integer("grams"),
	otherGrams: varchar("other_grams", { length: 64 }),
	// Refills: 1 | 2 | 4 | 6 | 11
	refills: integer("refills").notNull().default(1),
	otherCompoundedPrescription: text("other_compounded_prescription"),
	notes: text("notes"),
	startDate: timestamp("start_date", { withTimezone: true }),
	endDate: timestamp("end_date", { withTimezone: true }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
